import {Component, OnDestroy, OnInit} from '@angular/core';
import {NbDialogService} from '@nebular/theme';
import {PvRecruitmentDialogReactivateAccountComponent} from './pv-recruitment-dialog-reactivate-account/pv-recruitment-dialog-reactivate-account.component';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {PvRecruitmentService} from './pv-recruitment.service';
import {LogInWithToken} from '../../shared/store/user/auth.actions';
import {Store} from '@ngrx/store';
import {UserState} from '../../shared/store/user/auth.state';

@Component({
  selector: 'pv-pv-recruitment',
  templateUrl: './pv-recruitment.component.html',
  styleUrls: ['./pv-recruitment.component.scss']
})
export class PvRecruitmentComponent implements OnInit, OnDestroy {
  private subs: Subscription[] = [];
  private fbclid: string | undefined;

  constructor(private dialogService: NbDialogService,
              private activeRoute: ActivatedRoute,
              private recruitmentService: PvRecruitmentService,
              private router: Router,
              private store: Store<UserState>) { }

  ngOnInit(): void {
    this.subs.push(this.activeRoute.queryParams.subscribe(queryParams => {
      this.fbclid = queryParams.fbclid; // Facebook click id
      if (queryParams.page === 'login') {
        setTimeout(() => {
          this.showConnexionDialog();
        }, 0);
      } else if (queryParams.token) {
        const payload = {
          redirectUrl: '/recruitment-process',
          token: queryParams.token
        };
        this.store.dispatch(
          new LogInWithToken(payload)
        );
      }
    }));
    this.recruitmentService.fbEvent('PageView', this.fbclid).catch(error => {
      console.error(error);
    });
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

  public showRecruitmentPage() {
    this.router.navigate(['/', 'inscription'], {
      state: {
        dialogStep: 0,
        retry: false
      }
    });
    this.recruitmentService.gaPageEvent('recruitement-dialog');
    this.recruitmentService.fbEvent('ViewContent', this.fbclid).catch(error => {
      console.error(error);
    });
  }

  public showConnexionDialog() {
    this.dialogService.open(PvRecruitmentDialogReactivateAccountComponent, {});
    this.recruitmentService.gaPageEvent('login-dialog');
  }

}
